import React, { useState, useEffect } from 'react';
import classes from './Apf.module.css';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Nav from './../Nav/hmdn';
import Ftr from './../Footer/Ftr';
import Cookies from 'js-cookie';
axios.defaults.withCredentials = true;

const Addproductform = () => {
  const userPrimaryKeyCookie = Cookies.get('userPrimaryKey');
  const [value, setValue] = useState({
    id: uuidv4(),
    name: '',
    productid: '',
    price: '',
    quantity: '',
    weight: '',
    ratings: "5",
    desc: '',
    selectedFiles: [],
    isAvailable: 0
  });

  const navigate = useNavigate();


  const handleGoBack = () => {
    navigate('/Admin_dashboard');
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append('id', value.id);
    formData.append('name', value.name);
    formData.append('productid', value.productid);
    formData.append('price', value.price);
    formData.append('quantity', value.quantity);
    formData.append('weight', value.weight);
    formData.append('ratings', value.ratings);
    formData.append('desc', value.desc);
    formData.append('isAvailable', value.isAvailable);

    for (let i = 0; i < value.selectedFiles.length; i++) {
      formData.append('images', value.selectedFiles[i]);
    }

    try {
      const response = await axios.post('https://infisea.com/addproduct', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log(response);

      if (response.data === 'error') {
        alert(
          'YOUR EMAIL OR MOBILE IS ALREADY REGISTER. PLEASE TRY LOGIN WITH OLD ACCOUNT OR USE ANOTHER CREDENTIALS'
        );
      } else {
        alert('Product Added Successfully');
      }
    } catch (err) {
      console.log(err);
    }
  };


  
 const handleGoLogin= () => {
       navigate('/login');
  };




/*

  // Check session status every 5 minutes (adjust the interval as needed)
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get('https://infisea.com/session');
    //    const isAuthenticated = response.data.isAuthenticated;

   //     if (!isAuthenticated) {
          // Session expired, perform logout
        //  handleLogout();
       // }
      } catch (error) {
        console.error('Error checking session status:', error);
      }


    };

//const sessionCheckInterval = setInterval(checkSession, 10 * 1000); // Check every 10 seconds
    //const sessionCheckInterval = setInterval(checkSession, 5 * 60 * 1000);
   // return () => clearInterval(sessionCheckInterval);
  }, []);



  if (!userPrimaryKeyCookie) {
    // You can add loading spinner or handle the case when user data is not loaded yet
    return <p><br/>
        <center> <button className={classes.addToCart} onClick={handleGoLogin}> ←  GO BACK To Login Page</button> </center>
      <br /></p>;
  }

*/
  return (
    <div>
      <Nav />
      <br /><br /><br />
      <div className={classes.Su}>
        <form className={`${classes.form} ${classes.card}`} encType="multipart/form-data" onSubmit={(e) => e.preventDefault()}>
          <div className={classes.card_header}>
            <h1 className={classes.form_heading}>ADD PRODUCT</h1>
          </div>

          <div className={classes.field}>
            <label htmlFor="name">Product Name</label>
            <input className={classes.input} name="name" type="text" placeholder="Your Product's Name" id="name"  onChange={e => setValue({ ...value, name: e.target.value })}  required />
          </div>

          <div className={classes.field}>
            <label htmlFor="productid">Product Id</label>
            <input className={classes.input} name="productid" type="text" placeholder="Your Product's Id" id="productid" onChange={e => setValue({...value, productid: e.target.value})} required/>
         </div>

        <div className={classes.field}>
            <label htmlFor="price">Price</label>
            <input className={classes.input} name="price" type="text"  placeholder="Write price of the Product" id="price" onChange={e => setValue({...value, price: e.target.value})} required/>
        </div>


        <div className={classes.field}>
            <label htmlFor="quantity">Stock Quantity</label>
            <input className={classes.input} name="quantity" type="text"  placeholder="Quantity of Product" id="quantity" onChange={e => setValue({...value, quantity: e.target.value})} required/>
        </div>

        <div className={classes.field}>
            <label htmlFor="weight">Weight</label>
            <input className={classes.input} name="weight" type="text"  placeholder="Weight of Product" id="weight" onChange={e => setValue({...value, weight: e.target.value})} required/>
        </div>


        <div className={classes.field}>
            <label htmlFor="Rating">Ratings</label>
           <select className={classes.input} value={value.ratings} onChange={e => setValue({...value, ratings: e.target.value})} required>
            <option value="0">0</option>
            <option value="0.5">0.5</option>
            <option value="1">1</option>
            <option value="1.5">1.5</option>
            <option value="2">2</option>
            <option value="2.5">2.5</option>
            <option value="3">3</option>
            <option value="3.5">3.5</option>
            <option value="4">4</option>
            <option value="4.5">4.5</option>
            <option value="5">5</option>

            </select>

        </div>


          <div className={classes.field}>
            <label htmlFor="desc">Description</label>
            <textarea className={classes.input} name="description" type="text" placeholder="Write About Product" id="description" rows={4} cols={50} onChange={e => setValue({...value, desc: e.target.value})} required/>
         </div>

          <div className={classes.field}>
            <input type="file" multiple onChange={(e) => setValue({ ...value, selectedFiles: e.target.files })} />
          {/*  <button type="button">Upload </button> */}
          </div>

          <div className={classes.field}>
            <label htmlFor="isAvailable">Is Available</label>
            <input type="checkbox" name="isAvailable" id="isAvailable" checked={value.isAvailable} onChange={(e) => setValue({ ...value, isAvailable: e.target.checked ? 1 : 0 })}/>
          </div>

          <div className={classes.field}>
            <input type="submit" value="Add Product" className={classes.button} onClick={handleUpload} />
          </div>

          Click Here To VIEW PRODUCTS
          <Link to="/Viewproduct"> <button className={classes.kd}>View</button></Link>
        </form>
      </div>
      <center> <button className={classes.addToCart} onClick={handleGoBack}> ←  GO BACK</button> </center>
      <br />
      <Ftr />
    </div>
  );
};

export default Addproductform;
